const DibbleConfigs = {
    apiEndpoint: {
        'development': 'https://api.giverise.app/api',
        'production': 'https://api.giverise.app/api'
    },
    downloadInvoiceUri: {
        'development': 'https://staging.lvbh.marinapro.app/backend/api/download_file.php?',
        'production': 'https://api.lvbh.marinapro.app/backend/api/download_file.php?'
    }
};

export default DibbleConfigs;
